/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Replace material composition
 */
export const updateMaterialCompositionBodyComponentsItemQuantityExclusiveMin = 0;

export const UpdateMaterialCompositionBody = zod
  .object({
    components: zod.array(
      zod.object({
        componentCatalogItemId: zod
          .uuid()
          .describe("Identity shared by Material and Service Catalog Items."),
        quantity: zod
          .number()
          .gt(updateMaterialCompositionBodyComponentsItemQuantityExclusiveMin)
          .describe(
            "Positive quantity interpreted using the referenced Catalog Item unit or billing unit.",
          ),
      }),
    ),
  })
  .describe("Complete replacement Catalog Item composition; an empty collection derives SIMPLE.");

export const UpdateMaterialCompositionResponse = zod.void();
